import { render, staticRenderFns } from "./VendorCharges.vue?vue&type=template&id=6460d43f&scoped=true"
import script from "./VendorCharges.vue?vue&type=script&lang=js"
export * from "./VendorCharges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6460d43f",
  null
  
)

export default component.exports